

function Spinner(){
    return(
        <div>


<div className="spinner"></div>
        </div>
    )
}
export default Spinner;